import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'
import { initSentry } from './config/sentry'

initSentry()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Ein unerwarteter Fehler ist aufgetreten.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
